var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLayers64Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9733 49.44L12.32 34.16L8 37.52L32 56.1867L56 37.52L51.6533 34.1333L31.9733 49.44ZM32 42.6667L51.6267 27.3867L56 24L32 5.33334L8 24L12.3467 27.3867L32 42.6667ZM32 12.08L47.3067 24L32 35.92L16.6933 24L32 12.08Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 15.0294,
    y1: 48.7394,
    x2: 50.9283,
    y2: 14.8548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0033AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0033AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLayers64Px);
export default __webpack_public_path__ + "static/media/ic_layers_64px.30dc1e60c0b70a00ade51f7ebfc848f4.svg";
export { ForwardRef as ReactComponent };